import { useEffect, useRef, useState, type CSSProperties } from 'react';
import { WorkingTutorPanel } from './WorkingTutorPanel';
import { blankWorking } from './workingCanvas';
import { WorkingOverlayContext, useWorkingViewport, type WorkingPanel } from './workingOverlay';
import './mathToolTutor.css';
import { useToolTutorDock } from './toolTutorDock';

export function MathToolTutor({
  subjectKey = 'mathematics',
  toolId,
  name,
  year,
  state,
  openRequest = 0,
}: {
  subjectKey?: 'mathematics' | 'chemistry' | 'physics';
  toolId: string;
  name: string;
  year: number;
  state: Record<string, unknown>;
  openRequest?: number;
}) {
  const [sessionId] = useState(() => crypto.randomUUID());
  const [panel, setPanel] = useState<WorkingPanel>(null);
  useEffect(() => {
    if (openRequest) setPanel('tutor');
  }, [openRequest]);
  const snapshot = JSON.stringify({ model_version: 1, year, ...state });
  const current = useRef({ snapshot, version: 1 });
  if (current.current.snapshot !== snapshot)
    current.current = { snapshot, version: current.current.version + 1 };
  const viewport = useWorkingViewport(panel !== null);
  const host = useRef<HTMLDivElement>(null);
  const dock = useToolTutorDock(host, panel !== null);
  const sheetStyle = {
    ...dock.style,
    '--working-viewport-height': `${viewport.height}px`,
    '--working-viewport-top': `${viewport.top}px`,
  } as CSSProperties;
  const [content] = useState(blankWorking);
  return (
    <WorkingOverlayContext.Provider
      value={{
        panel,
        setPanel,
        fullScreen: true,
        portalTarget: dock.target,
        sheetStyle,
        shortViewport: viewport.height <= 500,
      }}
    >
      <div ref={host} className="math-tool-tutor shrink-0" style={sheetStyle}>
        <WorkingTutorPanel
          tool={{
            subject_key: subjectKey,
            tool_id: toolId,
            name,
            year,
            snapshot,
            session_id: sessionId,
            version: current.current.version,
          }}
          content={content}
          disabled={false}
          assessment={false}
          flush={async () => null}
        />
      </div>
    </WorkingOverlayContext.Provider>
  );
}
